import { Component, Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-filterable-table',
    templateUrl: './filterable-table.component.html'
})
export class FilterableTableComponent implements OnInit {
    public searchItem: UntypedFormGroup;
    public showList = false;
    public selected = 0;
    public rows;

    private _selectedItem: UntypedFormGroup;

    get selectedItem(): UntypedFormGroup { return this._selectedItem; }
    @Input() set selectedItem(item: UntypedFormGroup) {
        this._selectedItem = item;
        if (this._selectedItem && this._selectedItem.value) {
            this.searchItem.get('des').patchValue(this.getSelectedItem());
        }
        this.searchItem.get('des').setValidators(item.validator);
        this.searchItem.updateValueAndValidity();

        if (this._selectedItem.disabled) {
            this.searchItem.disable();
        } else {
            this.searchItem.enable();
        }
    }
    @Input() itemsList: Array<any>;
    @Input() disabled: Subject<boolean>;
    @Input() columns: Array<any>;
    @Input() properties: Array<any>;
    @Input() placeHolder: Array<any>;

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.showList = false;
            if (this.selectedItem && this.selectedItem.value) {
                this.searchItem.get('des').patchValue(this.getSelectedItem());
            } else {
                this.searchItem.reset();
            }
        }
    }

    constructor(private _fb: UntypedFormBuilder, private eRef: ElementRef, private renderer: Renderer2) {
        this.searchItem = this._fb.group({
            id: [''],
            des: ['']
        });
    }

    ngOnInit() {
        this._selectedItem.valueChanges.subscribe(() => {
            if (this._selectedItem && this._selectedItem.value) {
                this.searchItem.get('des').patchValue(this.getSelectedItem());
            } else {
                this.searchItem.reset();
            }

            if (this._selectedItem && this._selectedItem.validator) {
                this.searchItem.get('des').setValidators(this._selectedItem.validator);
                this.searchItem.updateValueAndValidity();
            }

        });


        if (this.disabled) {
            this.disabled.subscribe(disable => {
                if (disable) {
                    this.searchItem.disable();
                } else {
                    this.searchItem.enable();
                }
            });
        }
    }

    public reset() {
        this.searchItem.reset();
        this.selectedItem.reset();
        this.showList = false;
    }

    public selectItem(item) {
        this.searchItem.patchValue(item);
        this.selectedItem.patchValue(item);
        this.showList = false;
    }

    public selectItemEnter() {
        this.searchItem.patchValue(this.filteredList[this.selected]);
        this.selectedItem.patchValue(this.filteredList[0]);
        this.showList = false;

    }

    public get filteredList() {
        if (this.itemsList) {
          return this.itemsList.filter(x => x.des.toUpperCase().includes(this.searchItem.get('des').value ? this.searchItem.get('des').value.toUpperCase() : ''));
        }
    }

    public setDisable(disable) {
        if (disable) {
            this.searchItem.disable();
        } else {
            this.searchItem.enable();
        }
    }

    public select(up) {

        if (up) {
            if (this.selected > 0) {
                this.selected--;
                const slides = document.getElementById('item' + this.selected);
                slides.scrollIntoView({ block: 'nearest', inline: 'start' });
            }
        } else {
            if (this.selected < (this.filteredList.length - 1)) {
                this.selected++;
                const slides = document.getElementById('item' + this.selected);
                slides.scrollIntoView({ block: 'nearest', inline: 'start' });
            }
        }
    }

    public getSelectedItem() {
        let property1 = '';
        let property2 = '';
        let property3 = '';

        if (this.selectedItem.value[this.properties[0]]) {
            property1 = this.selectedItem.value[this.properties[0]];
        }

        if (this.selectedItem.value[this.properties[1]]) {
            property2 = this.selectedItem.value[this.properties[1]];
        }

        if (this.selectedItem.value[this.properties[2]]) {
            property3 = this.selectedItem.value[this.properties[2]];
        }
        return (property1 + ' - ' + property2 + ' - ' + property3);
    }

    public getPlaceholder() {
        let placeholder = '';

        if (this.placeHolder && this.itemsList && this.itemsList !== null) {
          if (this.itemsList.length > 1) {
            placeholder = this.itemsList[0].des + ',' + ' ' + this.itemsList[1].des + '...';
          } else {
            placeholder = this.itemsList[0] ? this.itemsList[0].des : ' ';
          }
        }
        return placeholder;
      }
}
